'use client';
import styled from 'styled-components';
import { colors } from '@/styles';

export const ModelsTable = styled.table`
  border-collapse: collapse;
  /* border: 1px solid ${colors.secondary.lightGray3}; */
  width: 100%;

  th,
  td {
    border: 1px solid ${colors.secondary.lightGray3};
    padding: 5px 10px;
    &.center {
      text-align: center;
    }
    &.right {
      text-align: right;
    }
  }
  thead {
    th {
      font-weight: 600;
      text-align: left;
      &:empty,
      &.title-cell {
        background-color: transparent;
        border: none;
      }
      .debold {
        font-weight: 400;
      }
    }
  }
  tr {
    border-bottom: 1px solid ${colors.secondary.lightGray3};
    &.selected {
      td {
        font-weight: 500;
        background-color: ${colors.semantic.information.light};
      }
    }
  }
  th {
    background-color: ${colors.secondary.lightGray2};
  }
  td {
    background-color: ${colors.primary.white};
  }
  .developer-logo,
  .provider-logo {
    height: 16px;
    min-width: 16px;
  }
`;
